import { Switch, Route } from "wouter";
import { HelmetProvider } from "react-helmet-async";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import CookieBanner from "@/components/CookieBanner";
import Analytics from "@/pages/Analytics";
import Alerts from "@/pages/Alerts";
import Brief from "@/pages/Brief";
import FAQ from "@/pages/FAQ";
import GetStarted from "@/pages/GetStarted";
import Help from "@/pages/Help";
import Home from "@/pages/Home";
import Ideas from "@/pages/Ideas";
import Maps from "@/pages/Maps";
import RadarGuide from "@/pages/RadarGuide";
import MarketRadar from "@/pages/MarketRadar";
import Monitor from "@/pages/Monitor";
import Reports from "@/pages/Reports";
import Signals from "@/pages/Signals";
import Status from "@/pages/Status";
import Terminal from "@/pages/Terminal";
import Video from "@/pages/Video";
import VideoPopout from "@/pages/VideoPopout";
import SignalToast from "@/components/SignalToast";
import NotFound from "@/pages/not-found";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/news" component={Terminal} />
      <Route path="/monitor" component={Monitor} />
      <Route path="/video/popout/:channelSlug" component={VideoPopout} />
      <Route path="/video/:channelSlug" component={Video} />
      <Route path="/video" component={Video} />
      <Route path="/brief" component={Brief} />
      <Route path="/analytics" component={Analytics} />
      <Route path="/reports" component={Reports} />
      <Route path="/get-started" component={GetStarted} />
      <Route path="/help" component={Help} />
      <Route path="/faq" component={FAQ} />
      <Route path="/status" component={Status} />
      <Route path="/signals" component={Signals} />
      <Route path="/ideas" component={Ideas} />
      <Route path="/maps" component={Maps} />
      <Route path="/radar/guide" component={RadarGuide} />
      <Route path="/radar" component={MarketRadar} />
      <Route path="/alerts">
        <Alerts />
      </Route>
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router />
        <CookieBanner />
        <Toaster />
        <SignalToast />
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
